import React from 'react';
import { Utils } from './../utils/Utils.js';
import NrgSchema from './NrgSchema.jsx';

export default class DocumentHead extends React.Component {

  render() {
    const canonicalUrl = this.getCanonicalUrl(this.props.page);
    const title = this.getPageTitle(this.props.page);
    const nrgschema = <NrgSchema />;

    return (
      <head>
        <meta charSet="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <link rel="canonical" href={canonicalUrl} />
        <link rel="stylesheet" href="../assets/css/bootstrap.min.css"/>
        <link rel="stylesheet" href="../assets/css/app.css"/>
        <title>{title}</title>
        <link rel="shortcut icon" href="../assets/img/favicon.png"/>
        {nrgschema}
      </head>
    );
  }

  shouldComponentUpdate() {
    return false;
  }

  getCanonicalUrl(pageName) {
    var rootUrl = 'http://nationalresearchgroup.com';

    switch (pageName) {
      case 'homepage':
        return rootUrl;
      default:
        return `${rootUrl}/${pageName}`;
    }
  }

  getPageTitle(pageName) {
    var title = '| National Research Group (NRG) Entertainment Market Research';

    switch(pageName) {
      case 'homepage':
        return `Thinking ${title}`;
      default:
        return `${Utils.ucFirst(pageName)} ${title}`;
    }
  }

};
